import * as React from 'react';
import {FunctionComponent} from 'react';
import {addSeconds, format, startOfWeek} from 'date-fns';
import {classNames} from '../../../../Support/classNames';
import {CalendarEvent} from '../../../../../Models/CalendarEvent';
import {utcToZonedTime} from 'date-fns-tz';
import {RsvpResponseButtons} from '../RsvpResponseButtons/RsvpResponseButtons';
import {Me} from '../../../../../Models/Me';
import {RsvpResponseBar} from '../RsvpResponseBar/RsvpResponseBar';

interface OwnProps {
    me: Me;
    referenceDate: Date;
    calendarEvents: CalendarEvent[];
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
    onCreateClick: (date: Date) => void;
    className?: string;
}

export const MobileCalendar: FunctionComponent<OwnProps> = ({
    me,
    referenceDate,
    calendarEvents,
    onCalendarEventClick,
    className,
}) => {
    const week: Array<{
        number: number;
        date: Date;
    }> = [];

    const firstDayInWeek = startOfWeek(referenceDate, {
        weekStartsOn: 1,
    });
    for (let i = 0; i < 7; i++) {
        week.push({
            number: firstDayInWeek.getDate() + i,
            date: new Date(firstDayInWeek.getFullYear(), firstDayInWeek.getMonth(), firstDayInWeek.getDate() + i),
        });
    }

    return (
        <div className={classNames('calendar-mobile', className)}>
            {calendarEvents.map((calendarEvent, index) => {
                const startAt = utcToZonedTime(calendarEvent.startAt, calendarEvent.timezone);
                return (
                    <div className="calendar-mobile__event" key={index}>
                        <div className="w-100 d-flex flex-row justify-content-between">
                            <strong>{calendarEvent.title}</strong>
                            <span>
                                {format(startAt, 'eeeeee d LLL') +
                                    ' ' +
                                    format(startAt, 'H:mm') +
                                    ' - ' +
                                    format(addSeconds(startAt, calendarEvent.duration.seconds), 'H:mm')}
                            </span>
                        </div>
                        {calendarEvent.description !== '' && <span>{calendarEvent.description}</span>}
                        <div className="w-100 d-flex flex-row justify-content-between mt-3">
                            <button
                                className="btn btn-outline-secondary"
                                onClick={() => onCalendarEventClick(calendarEvent)}
                            >
                                View
                            </button>
                            <RsvpResponseButtons userId={me.id} calendarEvent={calendarEvent} />
                        </div>
                        <div className="w-100">
                            <RsvpResponseBar calendarEvent={calendarEvent} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
